import { Capacitor } from '@capacitor/core';

// Native (iOS/Android) platformlarda çalışan başlatma kodu.
// Web tarayıcıda hiçbir şey yapmaz; mevcut web davranışı korunur.
export const initNativePlatform = async () => {
  if (!Capacitor.isNativePlatform || !Capacitor.isNativePlatform()) {
    return;
  }

  // Native'e özel CSS kurallarını etkinleştirmek için gövde sınıfı
  document.body.classList.add('capacitor-native');
  document.body.classList.add(`platform-${Capacitor.getPlatform()}`);

  try {
    const { StatusBar, Style } = await import('@capacitor/status-bar');
    // Koyu lacivert marka rengiyle uyumlu, açık renk ikonlar
    await StatusBar.setStyle({ style: Style.Dark });
    if (Capacitor.getPlatform() === 'android') {
      await StatusBar.setBackgroundColor({ color: '#0f2c4d' });
    }
    // İçerik durum çubuğunun altına girmesin (overlay kapalı)
    await StatusBar.setOverlaysWebView({ overlay: false });
  } catch (e) {
    // Plugin yoksa sessizce geç
  }

  try {
    const { Keyboard, KeyboardResize } = await import('@capacitor/keyboard');
    await Keyboard.setResizeMode({ mode: KeyboardResize.Native });
  } catch (e) {}

  try {
    const { SplashScreen } = await import('@capacitor/splash-screen');
    // İçerik hazır olduğunda splash'ı gizle
    await SplashScreen.hide();
  } catch (e) {}
};
